import { Either } from 'src/utils/either';

import { httpResponseHandler } from 'src/http/http-response-handler';

import {
  HttpTypes,
  BadRequestError,
  ConnectionError,
  UnexpectedError,
  AccessDeniedError,
  InternalServerError,
  TooManyRequestsError,
  ConflictError,
} from '../../http';

export class FairsRepository {
  constructor(private api: HttpTypes.HttpClient) {}

  async getFairList(): Promise<
    | Either<
        | BadRequestError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        undefined
      >
    | any
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: `benefits/fair/all`,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getFairDetails(id: string): Promise<
    | Either<
        | BadRequestError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        undefined
      >
    | any
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: `benefits/fair/details`,
      params: { id }
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async createFair(fair: any): Promise<
    | Either<
        | BadRequestError
        | ConflictError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        undefined
      >
    | any
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: `benefits/fair/create`,
      body: fair
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async updateFair(id: string, fair: any): Promise<
    | Either<
        | BadRequestError
        | ConflictError
        | UnexpectedError
        | InternalServerError
        | AccessDeniedError
        | ConnectionError
        | TooManyRequestsError,
        undefined
      >
    | any
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'put',
      url: `benefits/fair/update`,
      params: { id },
      body: fair
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }
}
